import React, { useEffect, useMemo, useRef } from 'react'

import OrderModalItem from '../OrderModalItem';

import { ContainerDesktop, ContainerMobile, Content } from './styles'
import { CSSTransition } from 'react-transition-group';
import { onDisabledScrollHandler, onEnableScrollHandler } from '../../utils/ScrollHandler';
import HeaderFilter from '../HeaderFilter';


interface IOrderModalProps {
    isOpen: boolean;
    onClose: () => void;
    orderConfigs: {
        key: string;
        itemName: string;
        itemValue: string;
    }[]
    onOrderHandler: (key: string, value: string) => void;
    orderSelected?: string;
}

const OrderModal: React.FC<IOrderModalProps> = ({
    isOpen,
    onClose,
    orderConfigs,
    onOrderHandler,
    orderSelected
}) => {

    const nodeRef = useRef(null)

    const orderModalContent = useMemo(() => (
        <>
            <HeaderFilter onClose={onClose}> Ordenar </HeaderFilter>

            <Content>
                {
                    orderConfigs.map((orderConfig) => (
                        <OrderModalItem
                            key={orderConfig.itemName}
                            objtKey={orderConfig.key}
                            label={orderConfig.itemName}
                            value={orderConfig.itemValue}
                            onClickOrderButtonHandler={onOrderHandler}
                            active={orderSelected === orderConfig.itemName}
                        />
                    ))
                }
            </Content>
        </>
    ), [onClose, onOrderHandler, orderConfigs, orderSelected])
    
    useEffect(() => {
        if(isOpen) {
            if(window.screen.width < 767) {
                onDisabledScrollHandler()
            }
        } else {
            onEnableScrollHandler()
        }
    },[isOpen])

    return (
        <>
            <ContainerDesktop className={`${isOpen && 'isOpen'}`}>
                {orderModalContent}
            </ContainerDesktop>

            <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={400} classNames="top_bottom_effect" unmountOnExit>
                <ContainerMobile ref={nodeRef}>
                    {orderModalContent}
                </ContainerMobile>
            </CSSTransition>
        </>
    )
}


export default OrderModal